/*
  Quick shop / "Select Options" modal: apply the same variant rules as the product page
  picker (snippets/custom-variants.liquid).

  - Options are filtered in order: a value is shown only if a variant exists for it
    together with the options chosen before it (e.g. Unstitched -> no sizes,
    Stitched -> XS...XL).
  - If the current choice becomes invalid, the first available value is selected.
  - A group whose only value is "Default" is hidden.
  - "Custom Size" needs the measurement form, so it is hidden here and a link to the
    product page is shown instead.
*/
(function () {
  if (window.__pzQuickVariants) return;
  window.__pzQuickVariants = true;

  var LIST_SELECTOR = '.product-variant-modal__variant-list';

  function norm(value) {
    return String(value || '').trim().toUpperCase();
  }

  function isCustom(value) {
    return norm(value).indexOf('CUSTOM') !== -1;
  }

  function setup(list) {
    if (list.__pzApply) return list.__pzApply;

    var dataEl = list.querySelector('script[data-pz-variants]');
    if (!dataEl) return null;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }

    var groups = Array.prototype.slice.call(list.querySelectorAll('.xo-product-variant'));
    if (!groups.length) return null;

    var customNote = list.querySelector('.pz-qv-custom');

    function radiosOf(group) {
      return Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
    }

    function apply() {
      var chosen = [];
      var toSelect = null;

      groups.forEach(function (group, position) {
        var radios = radiosOf(group);

        radios.forEach(function (radio) {
          var matches = variants.filter(function (variant) {
            for (var i = 0; i < position; i++) {
              if (variant.options[i] !== chosen[i]) return false;
            }
            return variant.options[position] === radio.value;
          });

          var exists = matches.length > 0;
          var available = matches.some(function (variant) { return variant.available; });
          var show = exists && !isCustom(radio.value);
          var label = radio.closest('label');

          if (label) {
            label.hidden = !show;
            label.classList.toggle('pz-qv-ok', show && available);
          }
          radio.__pzOk = show && available;
        });

        var selected = radios.filter(function (r) { return r.checked && r.__pzOk; })[0];
        if (!selected) {
          selected = radios.filter(function (r) { return r.__pzOk; })[0];
          if (selected && !toSelect) toSelect = selected;
        }
        if (!selected) {
          selected = radios.filter(function (r) { return r.checked; })[0];
        }
        chosen[position] = selected ? selected.value : null;

        var visible = radios.filter(function (r) {
          var label = r.closest('label');
          return label && !label.hidden;
        });
        group.hidden =
          visible.length === 1 &&
          (norm(visible[0].value) === 'DEFAULT' || norm(visible[0].value) === 'DEFAULT TITLE');
      });

      if (customNote) {
        customNote.hidden = !variants.some(function (variant) {
          for (var i = 0; i < variant.options.length; i++) {
            if (isCustom(variant.options[i])) {
              // Only relevant when the options chosen before the custom value match
              for (var j = 0; j < i; j++) {
                if (variant.options[j] !== chosen[j]) return false;
              }
              return true;
            }
          }
          return false;
        });
      }

      // Select one corrected value per pass; the resulting change event re-runs apply()
      if (toSelect) {
        toSelect.checked = true;
        toSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    list.__pzApply = apply;
    return apply;
  }

  function run(list) {
    var apply = setup(list);
    if (!apply) return;
    apply();
    // The theme re-evaluates availability on a 0ms debounce; settle after it
    setTimeout(apply, 60);
  }

  function initAll(root) {
    var lists = (root || document).querySelectorAll(LIST_SELECTOR);
    Array.prototype.forEach.call(lists, run);
  }

  document.addEventListener('change', function (event) {
    var list = event.target && event.target.closest && event.target.closest(LIST_SELECTOR);
    if (list) run(list);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Product cards added later (filters, infinite scroll, recommendations, editor)
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        pending = true;
        setTimeout(function () {
          pending = false;
          var lists = document.querySelectorAll(LIST_SELECTOR);
          Array.prototype.forEach.call(lists, function (list) {
            if (!list.__pzApply) run(list);
          });
        }, 150);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
